import {atom} from 'jotai';

export const hiddenMessageFromPrevScreen = atom('');
export const isEditingAtom = atom(false);
